import React from 'react';
import { History, UserCircle, Zap } from 'lucide-react';

const Layout = ({ children, activeTab, onNav }) => (
  <div className="min-h-screen bg-[#05050f] text-white font-sans pb-24 selection:bg-purple-500/30">
    <div className="max-w-md mx-auto px-4">{children}</div>
    {activeTab && (
      <nav className="fixed bottom-0 left-0 right-0 bg-[#0a0a1a]/95 backdrop-blur-lg border-t border-white/5 px-8 py-4 flex justify-around items-center z-50">
        <button
          onClick={() => onNav('dashboard')}
          className={`flex flex-col items-center gap-1 transition-colors ${
            activeTab === 'dash' ? 'text-purple-500' : 'text-gray-500'
          }`}
        >
          <Zap size={20} />
          <span className="text-[10px] font-black uppercase tracking-tighter">Admin</span>
        </button>
        <button
          onClick={() => onNav('history')}
          className={`flex flex-col items-center gap-1 transition-colors ${
            activeTab === 'history' ? 'text-purple-500' : 'text-gray-500'
          }`}
        >
          <History size={20} />
          <span className="text-[10px] font-black uppercase tracking-tighter">History</span>
        </button>
        <button
          onClick={() => onNav('profile')}
          className={`flex flex-col items-center gap-1 transition-colors ${
            activeTab === 'profile' ? 'text-purple-500' : 'text-gray-500'
          }`}
        >
          <UserCircle size={20} />
          <span className="text-[10px] font-black uppercase tracking-tighter">Profile</span>
        </button>
      </nav>
    )}
  </div>
);

export default Layout;
